import { useLocation } from 'react-router-dom';

const useUrlQueryParams = () => {
  const location = useLocation();
  return new URLSearchParams(location.search);
};

export default useUrlQueryParams;
